import { FC, ReactElement, useContext } from "react";
import {
  Snackbar,
  Slide,
  Alert,
  AlertTitle,
  SnackbarOrigin,
} from "@mui/material";

import { IMessageContext, MessageContext } from "@/context/message-context";
import { tokens } from "@/tokens";

const SnackbarMessage: FC = (): ReactElement => {
  const position: SnackbarOrigin = {
    vertical: "top",
    horizontal: "center",
  };

  const { snackbarState, hideSnackbar } = useContext(
    MessageContext
  ) as IMessageContext;

  const {
    variant,
    duration: autoHideDuration,
    isSnackbarVisible,
    snackBarMessage,
    snackBarDescription = "",
  } = snackbarState;

  const getColors = () => {
    if (variant === "error") {
      return tokens.status.danger;
    }
    if (variant === "success") {
      return "#27BE69";
    }
    if (variant === "warning") {
      return "#FFBF0F";
    }
    return tokens.brand.accent;
  };

  return (
    <Snackbar
      anchorOrigin={position}
      onClose={hideSnackbar}
      open={isSnackbarVisible}
      ClickAwayListenerProps={{
        mouseEvent: false,
      }}
      TransitionComponent={Slide}
      autoHideDuration={autoHideDuration}
    >
      <Alert
        severity={variant}
        sx={{
          minWidth: 300,
          padding: `10px 20px`,
          boxShadow: "0px 1px 4px 0px #0F172A0A",
          border: "1px solid #ebebeb",
          background: tokens.bg.surface,
          "& .MuiAlert-message": {
            color: "#5c5c5c",
            fontSize: tokens.fontSize.lg,
            whiteSpace: "pre-line",
          },
          "& .MuiAlertTitle-root": {
            color: getColors(),
            fontWeight: tokens.fontWeight.bold,
            fontSize: tokens.fontSize.lg,
          },
          "& .MuiAlert-icon": {
            color: getColors(),
          },
          "& .MuiIconButton-root": {
            color: tokens.text.subtle,
          },
        }}
        onClose={hideSnackbar}
      >
        <AlertTitle>{snackBarMessage}</AlertTitle>
        {snackBarDescription}
      </Alert>
    </Snackbar>
  );
};

export default SnackbarMessage;
